// extracted by mini-css-extract-plugin
export default {"list_container":"TaskList_list_container__o5DCi","list_content":"TaskList_list_content__lU1fv","list_functions":"TaskList_list_functions__soFW+"};